import { createSelector } from '@ngrx/store';
import { IImage } from '@shared/shared/interfaces/common.interfaces';
import { Amenity, Image } from '@shared/shared/interfaces/travel-hotel.interfaces';
import { isMobile } from '@shared/utils/platform';
import * as fromReducers from '../reducers';
import { getHotelAmenitiesFeatureState } from './hotel-amenities.selectors';

export const maxImageNumber = 75;

export const getHotelDetailsFeatureState = createSelector(
  fromReducers.getTravelSearchState,
  (state: fromReducers.TravelSearchState) => state.hotelDetails
);

export const getHotelDetails = createSelector(
  getHotelDetailsFeatureState,
  getHotelAmenitiesFeatureState,
  (hotelDetails, amenities) => {
    return {
      ...hotelDetails,
      amenities: hotelDetails.amenities
        ? hotelDetails.amenities
            .split(',')
            .map((id: string) => amenities.find((amenity: Amenity) => amenity.id === +id))
            .filter((amenity: Amenity) => !!amenity)
        : [],
      images: hotelDetails.images?.slice(0, maxImageNumber).map((image: Image) => {
        return {
          image: isMobile() ? `${image.source}?func=crop&w=480&sharp=1` : image.source,
        } as IImage;
      }),
    };
  }
);
